import logo_aiguille from '@img/Compozz_boussole_violet_centre_aiguille.svg';
import logo_C from '@img/Compozz_boussole_violet_centre_C.svg';
import logo_trait from '@img/Compozz_boussole_violet_centre_trait.svg';
import { TW_AppObjectCellSkeleton, TW_AppObjectHeaderSkeleton, TW_AppObjectLineSkeleton, TW_AppObjectModelViewSkeleton, TW_Spinner, TW_SpinnerLogo } from '@utils/twClasses';
import { Skeleton } from './skeleton';

function CompozzSpinner() {
  return (
    <div className={TW_Spinner}>
      <img src={logo_C} className={TW_SpinnerLogo + " animate-load-3"} alt="logo" height="80px" width="auto" />
      <img src={logo_trait} className={TW_SpinnerLogo + " animate-load-3"} alt="logo" height="80px" width="auto" />
      <img src={logo_aiguille} className={TW_SpinnerLogo + " animate-load-1.5"} alt="logo" height="80px" width="auto" />
    </div>
  );
}

export function CompozzObjectViewSpinner() {
  return (
    <>
      <div className={TW_AppObjectModelViewSkeleton}>
        <Skeleton className={TW_AppObjectHeaderSkeleton} />
        {Array.from({ length: 30 }).map((_, i) => (
          <div key={"skeleton-line-" + i} className={TW_AppObjectLineSkeleton}>
            {Array.from({ length: 10 }).map((_, j) => (
              <Skeleton key={"skeleton-cell-" + i + "-" + j} className={TW_AppObjectCellSkeleton} />
            ))}
          </div>
        ))
        }
      </div>
      <div className="flex justify-center items-center h-full w-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <CompozzSpinner />
      </div>
    </>
  )
}

export default CompozzSpinner;